import { cn } from '@/lib/classnames'

const Spinner = ({ className }: { className?: string }) => {
  return (
    <svg className={`animate-spin -ml-1 h-5 w-5 text-white ${className}`} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
      <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
    </svg>
  )
}

export const Spinner2 = () => {
  return (
    <svg className='animate-spin -ml-1 h-10 w-10 text-black ' xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
      <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
    </svg>
  )
}

interface Spinner3Props {
  text?: string
  global?: boolean
  className?: string
}

export const Spinner3 = ({ className, global, text }: Spinner3Props) => {
  const spinner = (
    <svg className={cn(`animate-spin -ml-1 h-5 w-5 text-black ${className}`)} xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
      <circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
      <path className='opacity-75' fill='currentColor' d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'></path>
    </svg>
  )

  if (global || text) {
    return (
      <div className='flex flex-col items-center justify-center gap-2'>
        {spinner}
        <div className='text-blue-950 text-sm'>{text}</div>
      </div>
    )
  }

  return spinner
}

export default Spinner
